﻿import { SwapCategory } from '../enums/index';
import { IPendingSwapDonor } from './pending-swap-donor';
import { IPendingSwapRecipient } from './pending-swap-recipient';
import { ILogistics } from './logistics';
import { IGpsAutomation } from './gps-automation';
import { ISingleEpletMmRisk } from './single-eplet-mm-risk';
import { ISwapManager } from './swap-manager';

export interface IPendingSwap {
    clusterId: number;
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    swapStatusValue: number;
    swapStatus: string;
    kickoffCallDateTime: string;
    logisticsCallDateTime: string;
    gpsId: string;
    transportMethod: string;
    cost: string;
    deadline: string;
    deadlineLocal: string;
    deadlineUtc: string;
    deadlineRemainingHours: number;
    mapLink: string;
    matchHistoryId: number;
    existingScreeningXm: boolean;
    existingScreeningXmStatus: string;
    existingFinalXm: boolean;
    existingFinalXmStatus: string;
    canRequestSerology: boolean;
    canRequestFinalXm: boolean;
    uploadedFinalXm: boolean;
    targetSurgeryDate: string;
    itemType: string;
    category: SwapCategory;
    donor: IPendingSwapDonor;
    recipient: IPendingSwapRecipient;
    tubes: string[];
    logistics: ILogistics;
    gpsAutomation: IGpsAutomation;
    singleEpletMmRisk: ISingleEpletMmRisk;
    swapManager: ISwapManager;
    bmtMm: number;
}
